import access_denied from "./Media/ACCESS_DENIED.jpg";
import dashbord_1 from "./Media/Check in.png";
import dashbord_2 from "./Media/Check out.png";
import dashbord_3 from "./Media/Cancelled.png";
import dashbord_4 from "./Media/Block list.png";
import NO_RECORDS_SVG from "./Media/no_records.svg";
import PS_LOGO from "./Media/PS-LOGO.jpg";
export const expression = {
  nric_regex: /^[ST]\d{7}[A-Z]$/,
  fin_regex: /^[FGM]\d{7}[A-Z]$/,
  nric_message: "Invalid NRIC: Format is S/T + 7 digits + 1 letter.",
  fin_message: "Invalid FIN: Format is F/G/M + 7 digits + 1 letter.",
  email: /^([a-zA-Z0-9_+\-\.]+)@([a-zA-Z\.]+)\.([a-zA-Z]{2,5})$/,
  space:
    /^[^\s].+([A-Za-z0-9!+@#$%^&*()_,/.-]+\s)*[A-Za-z0-9!+@#$%^&_(),/.-]+$/,
  Without_space: /^(?!\s).+(?<!\s)$/,
  space_message: "should not contain spaces",
  min_one_char: /^(\w| )*[A-Za-z](\w| )*$/,
  zipcode: /^[0-9-]*$/,
  char: /^[A-Za-z\s]+$/,
  percentage: /\b(?<!\.)(?!0+(?:\.0+)?%)(?:\d|[1-9]\d|100)(?:(?<!100)\.\d+)?%/,
};

export const PURPOSE_OF_TESTING_DATA = [
  { name: "BIS FULL TESTING", value: "BIS_FULLTESTING" },
  { name: "BIS MODIFICATION", value: "BIS_MODIFICATION" },
  { name: "NABL PERFORMANCE", value: "NABL_PERFORMANCE" },
  { name: "MEITY SURVEILANCE ORDER", value: "MEITY_SUR_ORDER" },
  { name: "R&D", value: "R_AND_D" },
  { name: "OTHERS", value: "OTHERS" },
];

export const role = [
  { name: "Admin", value: "ADMIN" },
  { name: "Front Office", value: "FRONT_OFFICE" },
];

export const NOTIFY_TYPE = {
  SMS: "SMS",
  EMAIL: "Email",
  WEB_PUSH: "Push Notification",
  ALL: "All",
};

export const OTP_ACTION = {
  SENT: "SENT",
  VERIFY: "VERIFY",
};

export const ROLE = {
  ADMIN: "ADMIN",
  FRONT_OFFICE: "FRONT_OFFICE",
};

export const TIMEZONE_LIST = [
  {
    name: "(GMT +5:30) Mumbai, Kolkata, Chennai, New Delhi",
    value: "Asia/Kolkata",
  },
  {
    name: "(GMT +8:00) Singapore, Singapore City",
    value: "Asia/Singapore",
  },
];

export const DATE_FORMAT_LIST = [
  {
    name: "DD-MM-YYYY",
    value: "DD-MM-YYYY",
  },
  {
    name: "DD/MM/YYYY",
    value: "DD/MM/YYYY",
  },
  {
    name: "YYYY-MM-DD",
    value: "YYYY-MM-DD",
  },
  {
    name: "YYYY/MM/DD",
    value: "YYYY/MM/DD",
  },
];

export const REMINDER_INTERVAL_SCOPE = [
  {
    name: "Creation Level",
    value: "CREATION_LEVEL",
  },
  {
    name: "Global Level",
    value: "GLOBAL_LEVEL",
  },
];
export const DATETIME_FORMAT_LIST = [
  {
    name: "DD-MM-YYYY HH:mm (24-hour)",
    value: "DD-MM-YYYY HH:mm",
  },
  {
    name: "DD-MM-YYYY hh:mm A (12-hour)",
    value: "DD-MM-YYYY hh:mm A",
  },
  {
    name: "YYYY-MM-DD HH:mm (24-hour)",
    value: "YYYY-MM-DD HH:mm",
  },
  {
    name: "YYYY-MM-DD HH:mm A (12-hour)",
    value: "YYYY-MM-DD HH:mm A",
  },
  {
    name: "ddd, MMM D, YYYY - HH:mm (24-hour)",
    value: "ddd, MMM D, YYYY - HH:mm",
  },
  {
    name: "ddd, MMM D, YYYY - HH:mm A (12-hour)",
    value: "ddd, MMM D, YYYY - HH:mm A",
  },
];

export const DEFAULTS = {
  TIME_ZONE: "Asia/Kolkata",
  DATE_TIME_FORMAT: "DD-MM-YYYY HH:mm",
  DATE_FORMAT: "DD/MM/YYYY",
  NOT_AVAILABLE: "N/A",
  FONT_SIZE: "15px",
  DEFAULT: "DEFAULT",
};

export const COMPONENTS = {
  MASKING: "MASKING",
  EMAIL: "EMAIL",
  PASSWORD: "PASSWORD",
};
export const CHAR_LIST = [
  { name: "A", value: "A" },
  { name: "B", value: "B" },
  { name: "C", value: "C" },
  { name: "D", value: "D" },
  { name: "E", value: "E" },
  { name: "F", value: "F" },
  { name: "G", value: "G" },
  { name: "H", value: "H" },
  { name: "I", value: "I" },
  { name: "J", value: "J" },
  { name: "K", value: "K" },
  { name: "L", value: "L" },
  { name: "M", value: "M" },
  { name: "N", value: "N" },
  { name: "O", value: "O" },
  { name: "P", value: "P" },
  { name: "Q", value: "Q" },
  { name: "R", value: "R" },
  { name: "S", value: "S" },
  { name: "T", value: "T" },
  { name: "U", value: "U" },
  { name: "V", value: "V" },
  { name: "W", value: "W" },
  { name: "X", value: "X" },
  { name: "Y", value: "Y" },
  { name: "Z", value: "Z" },
];

export const MASTER_SETTINGS = {
  HOST_DEPARTMENT: "HOST_DEPARTMENT",
  PURPOSE_OF_VISIT: "PURPOSE_OF_VISIT",
  CONFIG_CODE: "CONFIG_CODE",
  CLIENT: "CLIENT",
  DESTINATION: "DESTINATION",
  TYPE: "TYPE",
};
export const ACCESS_DENIED = access_denied;
export const DASHBOARD_ICON_1 = dashbord_1;
export const DASHBOARD_ICON_2 = dashbord_2;
export const DASHBOARD_ICON_3 = dashbord_3;
export const DASHBOARD_ICON_4 = dashbord_4;
export const NO_RECORDS_ICON = NO_RECORDS_SVG;
export const PS_LOGO_IMG = PS_LOGO;
export const MODULES = {
  DASHBOARD: "DASHBOARD",
  EMPLOYEE: "EMPLOYEE",
  VISITOR_LOGS: "VISITOR-LOGS",
  // BLACKLIST: "BLACKLIST",
  MASTER_SETTINGS: "MASTER-SETTINGS",
  CUSTOM_ROLES: "CUSTOM-ROLES",
  REMINDERS: "REMINDERS",
  OTHER_SETTINGS: "OTHER-SETTINGS",
};

export const ROLE_BY_PERMISSIONS = {
  [MODULES.DASHBOARD]: {
    SHOW_DASHBOARD: "SHOW_DASHBOARD",
  },
  [MODULES.EMPLOYEE]: {
    SHOW_EMPLOYEE: "SHOW_EMPLOYEE",
    STATUS_EMPLOYEE: "STATUS_EMPLOYEE",
    CHANGE_PASSWORD_EMPLOYEE: "CHANGE_PASSWORD_EMPLOYEE",
  },
  [MODULES.VISITOR_LOGS]: {
    CREATE_VISITOR_LOGS: "CREATE_VISITOR_LOGS",
    UPDATE_VISITOR_LOGS: "UPDATE_VISITOR_LOGS",
    STATUS_VISITOR_LOGS: "STATUS_VISITOR_LOGS",
    DELETE_VISITOR_LOGS: "DELETE_VISITOR_LOGS",
    SHOW_VISITOR_LOGS: "SHOW_VISITOR_LOGS",
    IMPORT_VISITOR_LOGS: "IMPORT_VISITOR_LOGS",
    EXPORT_VISITOR_LOGS: "EXPORT_VISITOR_LOGS",
    CHECKOUT_VISITOR_LOGS: "CHECKOUT_VISITOR_LOGS",
    PRINT_VISITOR_LOGS: "PRINT_VISITOR_LOGS",
  },
  // [MODULES.BLACKLIST]: {
  //   CREATE_BLACKLIST: "CREATE_BLACKLIST",
  //   DELETE_BLACKLIST: "DELETE_BLACKLIST",
  //   SHOW_BLACKLIST: "SHOW_BLACKLIST",
  // },
  [MODULES.MASTER_SETTINGS]: {
    SHOW_MASTER_SETTINGS: "SHOW_MASTER_SETTINGS",
    CREATE_MASTER_SETTINGS: "CREATE_MASTER_SETTINGS",
    UPDATE_MASTER_SETTINGS: "UPDATE_MASTER_SETTINGS",
    STATUS_MASTER_SETTINGS: "STATUS_MASTER_SETTINGS",
  },
  [MODULES.CUSTOM_ROLES]: {
    SHOW_CUSTOM_ROLES: "SHOW_CUSTOM_ROLES",
    CREATE_CUSTOM_ROLES: "CREATE_CUSTOM_ROLES",
    UPDATE_CUSTOM_ROLES: "UPDATE_CUSTOM_ROLES",
    STATUS_CUSTOM_ROLES: "STATUS_CUSTOM_ROLES",
  },
  [MODULES.REMINDERS]: {
    SHOW_REMINDERS: "SHOW_REMINDERS",
    CREATE_REMINDERS: "CREATE_REMINDERS",
    UPDATE_REMINDERS: "UPDATE_REMINDERS",
    STATUS_REMINDERS: "STATUS_REMINDERS",
    DELETE_REMINDERS: "DELETE_REMINDERS",
  },
  [MODULES.OTHER_SETTINGS]: {
    SHOW_OTHER_SETTINGS: "SHOW_OTHER_SETTINGS",
    CREATE_OTHER_SETTINGS: "CREATE_OTHER_SETTINGS",
    STATUS_OTHER_SETTINGS: "STATUS_OTHER_SETTINGS",
  },
};

export const PRINT_FONT_WEIGHT = [
  {
    name: "100",
    value: "100",
  },
  {
    name: "200",
    value: "200",
  },
  {
    name: "300",
    value: "300",
  },
  {
    name: "400",
    value: "400",
  },
  {
    name: "500",
    value: "500",
  },
  {
    name: "600",
    value: "600",
  },
  {
    name: "700",
    value: "700",
  },
  {
    name: "800",
    value: "800",
  },
  {
    name: "900",
    value: "900",
  },
  {
    name: "Bold",
    value: "bold",
  },
  {
    name: "Bolder",
    value: "bolder",
  },
  {
    name: "Lighter",
    value: "lighter",
  },
  {
    name: "Normal",
    value: "normal",
  },
];

export const PRINT_FONT_STYLE = [
  {
    name: "Normal",
    value: "normal",
  },
  {
    name: "Italic",
    value: "italic",
  },
];

export const PRINT_FONT_SIZE = [
  {
    name: "14px",
    value: "14px",
  },
  {
    name: "15px",
    value: "15px",
  },
  {
    name: "16px",
    value: "16px",
  },
  // {
  //   name: "17px",
  //   value: "17px",
  // },
  // {
  //   name: "18px",
  //   value: "18px",
  // },
];
